import React, { useEffect, useState } from "react";

import axios from "../utils/api";
import moment from "moment";
import "moment/locale/th";

const ReportMonkContext = React.createContext(null);
const useReportMonk = () => React.useContext(ReportMonkContext);

const getDates = (dates) => {
  return dates.map((d) => getDateOnly(d.createdAt));
};

const getDateOnly = (createdAt) => {
  return createdAt.split("T")[0];
};

const ReportMonkProvider = ({ children }) => {
  const [view, setView] = useState("byDate");
  const [mode, setMode] = useState("weeks");

  const [isLoading, setIsLoading] = useState(true);
  const [matchList, setMatchList] = useState([]);
  const [selectedMatchId, setSelectedMatchId] = useState(undefined);

  const [report, setReport] = useState(null);

  const [selectedDateIndex, setSelectedDateIndex] = useState(undefined);
  const [selectedWeekIndex, setSelectedWeekIndex] = useState(undefined);

  const [chartView, setChartView] = useState("cowMilkScore");

  const [chartOption, setChartOption] = useState({
    chart: {
      id: "reportMonkChart",
      locales: [
        {
          name: "en",
          toolbar: {
            download: "ดาวน์โหลด",
          },
        },
      ],
      toolbar: {
        show: false,
      },
      width: "100%",
    },
    xaxis: {
      type: "number",
      tickAmount: 15,
      min: 1,
      max: 16,
      title: {
        text: "สัปดาห์",
        style: {
          class: "",
        },
      },
    },
    yaxis: {
      tickAmount: 18,
      title: {
        text: "คะแนน",
        rotate: 0,
        offsetX: 30,
        offsetY: -198,
      },
      min: 0,
      max: 18,
      labels: {
        formatter: function (val, index) {
          return val.toFixed(0);
        },
      },
    },
  });

  // get match List
  useEffect(() => {
    axios
      .get("/matches/getMatchListByStudent")
      .then((r) => {
        if (r.status === 200) setMatchList(r.data.matchList);
      })
      .catch((err) => {
        alert("ไม่สามารถดึงข้อมูลรายการแข่งขันได้");
      });
  }, []);

  // useEffect(() => {
  //   if (matchList.length && matchList.length > 0) {
  //     setSelectedMatchId(matchList[0].id);
  //   }
  // }, [matchList]);

  useEffect(() => {
    setTimeout(() => {
      setSelectedDateIndex(undefined);
      setSelectedWeekIndex(undefined);
    }, 0);

    if (selectedMatchId) {
      setIsLoading(true);
      axios
        .get("/report/forStudent/individual/" + selectedMatchId)
        .then((r) => {
          if (r.status === 200) setReport(r.data.report);
          setIsLoading(false);
        })
        .catch((err) => {
          // alert("ไม่สามารถดึงข้อมูลการแข่งขันได้");
          setIsLoading(false);
        });
    }
  }, [selectedMatchId]);

  // useEffect(() => {
  //   if (report && report.dates && report.dates.length) {
  //     setSelectedDateIndex(0);
  //   }
  // }, [report]);

  const haveRewards = () => {
    const { rewards } = getCurrentWeek();
    if (rewards && Array.isArray(rewards) && rewards.length > 0) return true;

    return false;
  };

  const onChangeSelectMatch = (matchId) => {
    setSelectedMatchId(matchId);
  };

  const onChangeSelectDate = (date, dateString) => {
    if (!date) {
      selectedDateIndex(null);
    } else {
      const dateFormated = moment(date).format("YYYY-MM-DD");

      for (let i = 0; i < report.dates.length; ++i) {
        const _date = getDateOnly(report.dates[i].createdAt);

        console.log(dateFormated + " " + _date);
        if (dateFormated === _date) setSelectedDateIndex(i);
      }
    }
  };

  const haveDates = () =>
    report && report.dates && Array.isArray(report.dates) ? true : false;
  const haveWeeks = () =>
    report &&
    report.weeks &&
    report.cumulativeWeeks &&
    Array.isArray(report.weeks) &&
    Array.isArray(report.cumulativeWeeks)
      ? true
      : false;

  const getEnableDates = () => (haveDates() ? getDates(report.dates) : []);
  const getCurrentWeek = () =>
    report && selectedWeekIndex !== undefined
      ? report[mode][selectedWeekIndex]
      : {};
  const getCurrentDate = () =>
    report && selectedDateIndex !== undefined
      ? report.dates[selectedDateIndex]
      : {};
  const getCurrentDateInMoment = (dateFormat = "YYYY-MM-DD") => {
    const { createdAt } = getCurrentDate();
    if (!createdAt) return undefined;

    return moment(createdAt, dateFormat);
  };
  const getCurrentWeekNumber = (defaultValue = "") => {
    const { week } = getCurrentWeek();
    if (!week) return defaultValue;

    return week;
  };

  const getCurrentWeekTotal4D = (defaultValue = "") => {
    const { total4D } = getCurrentWeek();
    if (!total4D) return defaultValue;

    return total4D;
  };

  const getCurrentWeekRewards = () => {
    const { rewards } = getCurrentWeek();

    return rewards ? rewards : [];
  };

  const getCurrentWeekLastReward = () => {
    const currentWeekRewards = getCurrentWeekRewards();
    if (currentWeekRewards.length > 0) {
      console.log(currentWeekRewards[currentWeekRewards.length - 1]);
      return currentWeekRewards[currentWeekRewards.length - 1];
    }

    return undefined;
  };

  const getCurrentWeekOtherRewards = () => {
    const currentWeekRewards = getCurrentWeekRewards();
    if (currentWeekRewards.length > 1) {
      return currentWeekRewards
        .filter((_, i) => i < currentWeekRewards.length - 1)
        .reverse();
    }

    return [];
  };

  // level => ['allSchool', 'allLevel', 'allRoom']
  const getCurrentWeekRank = (level, defaultValue) => {
    const { rank } = getCurrentWeek();
    if (rank && rank[level]) return rank[level];

    return defaultValue;
  };

  /*
    v => ['cowMilkScore', 'vegetableScore', 'exerciseScore', 'sweetDrinkScore', 'total4D']
  */
  const changeChartView = (v) => {
    setChartView(v);
  };

  const setChartYAxis = (chartView) => {
    let max = 18;
    if (chartView === "total4D") max = 72;
    setChartOption({ ...chartOption, yaxis: { ...chartOption.yaxis, max } });
  };

  const getWeekOptions = () => {
    const prefixTextOption =
      mode === "weeks" ? "สัปดาห์ที่ " : "สัปดาห์ที่ 1 - ";
    return haveWeeks()
      ? report[mode].map((w, i) => ({
          name: prefixTextOption + w.week,
          value: i,
        }))
      : [];
  };

  const getTotalInformWeek = () => {
    const { cumulativeWeeks } = report;

    if (cumulativeWeeks && Array.isArray(cumulativeWeeks))
      return cumulativeWeeks.length;

    return 0;
  };

  const getWeekNumber = (at = "start") => {
    const { cumulativeWeeks } = report;

    if (
      cumulativeWeeks &&
      Array.isArray(cumulativeWeeks) &&
      cumulativeWeeks.length > 0
    )
      return at === "start"
        ? cumulativeWeeks[0].week
        : cumulativeWeeks[cumulativeWeeks.length - 1].week;

    return "-";
  };

  const getDataTable = (ObjectKey) => {
    if (report && report.all) {
      const { dataTable } = report.all;

      if (!ObjectKey) return dataTable;

      if (dataTable && dataTable[ObjectKey]) return dataTable[ObjectKey];
    }

    return {};
  };

  const getChartData = () => {
    const { all } = report;

    if (all && all.chart && all.chart[chartView]) return all.chart[chartView];

    return [];
  };

  const getCurrentWeekInform = (ObjectKey, defaultValue) => {
    const currentWeek = getCurrentWeek();

    if (currentWeek && currentWeek[ObjectKey]) return currentWeek[ObjectKey];

    return defaultValue;
  };

  const getCurrentDateInform = (ObjectKey, defaultValue) => {
    const currentDate = getCurrentDate();

    if (currentDate && currentDate[ObjectKey]) return currentDate[ObjectKey];

    return defaultValue;
  };

  const isSelectedDate = () => {
    if (!isNaN(selectedDateIndex)) return true;

    return false;
  };

  const isSelectedWeek = () => {
    if (!isNaN(selectedWeekIndex)) return true;

    return false;
  };

  useEffect(() => {
    setSelectedWeekIndex(undefined);
  }, [mode]);

  const value = {
    chartView,
    changeChartView,
    isLoading,
    chartOption,
    setChartYAxis,
    setChartOption,
    haveRewards,
    getEnableDates,
    getCurrentWeekNumber,
    getCurrentDateInMoment,
    getCurrentWeekRewards,
    getCurrentWeekLastReward,
    getCurrentWeekOtherRewards,
    matchList,
    onChangeSelectMatch,
    onChangeSelectDate,
    getWeekOptions,
    mode,
    setMode,
    selectedWeekIndex,
    setSelectedWeekIndex,
    view,
    setView,
    getTotalInformWeek,
    getWeekNumber,
    getDataTable,
    getChartData,
    getCurrentWeekTotal4D,
    getCurrentWeekRank,
    getCurrentWeekInform,
    getCurrentDateInform,
    getCurrentDatetotal4D: (defaultValue) =>
      getCurrentDateInform("total4D", defaultValue),
    isSelectedDate,
    isSelectedWeek,
  };

  return (
    <ReportMonkContext.Provider value={value}>
      {children}
    </ReportMonkContext.Provider>
  );
};

export { ReportMonkProvider, useReportMonk };
